import dynamic from "next/dynamic";
import { EventHero as UIEventHero } from "@business-finland/wif-ui-lib/dist/EventHero";
import { useRouter } from "next/router";

import { Viewport } from "@/constants/app";
import useViewport from "../../../../contexts/ViewportContext";
import useImageDataHandler from "../../../../hooks/useImageDataHandler";

const HtmlParser = dynamic(() => import("../../../../components/HtmlParser"));

export function EventHero(props: Wif.Mgnl.EventPage) {
  const {
    eventDateStart,
    eventDateEnd,
    image,
    heroTitle,
    heroDescription,
    eventLink,
    eventLocation,
    eventLinkLabel,
    eventLocationLabel,
    eventTimeLabel,
    altText,
    imageReference,
    leadText,
  } = props;

  const isLargeDesktop = useViewport().viewport === Viewport.xl;
  const { locale } = useRouter();

  const imageDataHandler = useImageDataHandler();
  const imageData = imageDataHandler(image);

  const eventDateStartAsDate = new Date(eventDateStart);
  const eventDateEndAsDate = eventDateEnd ? new Date(eventDateEnd) : undefined;

  return (
    <UIEventHero
      title={heroTitle}
      description={<HtmlParser html={heroDescription} />}
      image={{ ...imageData, imageSrc: imageData.src }}
      altText={altText}
      imageReference={imageReference}
      leadText={leadText}
      eventLink={eventLink}
      eventLocation={eventLocation}
      isLargeDesktop={isLargeDesktop}
      eventStartDate={eventDateStartAsDate}
      eventEndDate={eventDateEndAsDate}
      translations={{
        link: eventLinkLabel,
        location: eventLocationLabel,
        time: eventTimeLabel,
      }}
      locale={locale}
    />
  );
}
